import styled from 'styled-components'

export type CountPropsColor = {
  color?: 'textColor' | 'info'
}

export const Container = styled.div<CountPropsColor>`
  &&& {
    display: flex;
    align-items: center;
  }
`

export const InputCount = styled.input<CountPropsColor>`
  &&& {
    background-color: transparent !important;
    border: transparent !important;
    text-align: center !important;
    width: 30px !important;
    padding: 0px !important;
    color: ${({ theme }) => theme.colors?.textColor};
    text-align: center;
    font-size: 14px;
    font-style: normal;
    font-weight: 700;
    line-height: normal;
  }
`
